import { ButtonIcon, Tooltip } from 'canoe';
import React from 'react';

import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';
import { useTypographyNodeMarks } from 'craft/hooks/useTypographyNodeMarks';

interface FormatButtonProps {
  format: string;
  tooltip: string;
  shortcuts: string[];
  icon: any;
}

export const FormatButton = ({ format, icon, tooltip, shortcuts }: FormatButtonProps) => {
  const { marks, toggleMark } = useTypographyNodeMarks();
  const isActive = marks.indexOf(format) > -1;

  const FormatIcon = icon;
  return (
    <Tooltip
      placement="top"
      offset="xxs"
      content={<TooltipBodyWithShortcuts content={tooltip} shortcuts={shortcuts} />}
    >
      <ButtonIcon
        size="small"
        active={isActive}
        icon={FormatIcon}
        onMouseDown={(e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          toggleMark(format);
        }}
        radius="small"
        color="white"
      />
    </Tooltip>
  );
};
